import { useState, useRef, useMemo, useEffect } from "react"
import _ from 'lodash'


interface Record {
  id: string
}

interface IDataSource<T> {
  list: T[],
  total: number
}


export const useRowSelection = <T extends Record>(datasource: IDataSource<T>, primaryKey: (record: T) => string) => {
  // 所有选中的行数据
  const allSelectedRecordsRef = useRef(new Map<string, T>())
  //当前页全选标志 
  const currentAllSelectedRef = useRef({
    selected: false,
    count: 0
  })

  // 表格选择props
  const [rowSelection, setRowSelection] = useState({

    selectedRowKeys: getAllSelectedRecordIds(),
    onChange,
    onSelect: (selected: boolean, record: T) => {
      if (selected) {
        addRecordToMap(record)
      } else {
        removeRecordFromMap(record[primaryKey(record)])
      }
    },
    onSelectAll: function (selected: boolean, records: T[]) {
      //当前页全选切换
      currentAllSelectedRef.current = {
        selected,
        count: currentAllSelectedRef.current.count += 1
      }
    },
  })

  useEffect(() => {
    if (currentAllSelectedRef.current.selected) {
      datasource?.list.forEach(record => {
        addRecordToMap(record)
      })
    } else {
      datasource?.list.forEach(record => {
        removeRecordFromMap(record[primaryKey(record)])
      })
    }

    onChange(undefined, getAllSelectedRecords())
  }, [
    currentAllSelectedRef.current.count
  ])

  // 获取所有选中的行数据id
  function getAllSelectedRecordIds() {
    return Array.from(allSelectedRecordsRef.current.keys() || [])
  }

  function getAllSelectedRecords() {
    return Array.from(allSelectedRecordsRef.current.values() || [])
  }


  const addRecordToMap = (recod: T) => {
    allSelectedRecordsRef.current.set(recod[primaryKey(recod)], recod)
  }
  const removeRecordFromMap = (key: string) => {
    allSelectedRecordsRef.current.delete(key)
  }
  const clearRecordMap = () => {
    allSelectedRecordsRef.current.clear()
  }

  //当前页数据变化回调
  function onChange(ids: string[] | undefined, records: T[]) {
    setRowSelection((rowSelection) => {
      records.forEach((record: T) => {
        addRecordToMap(record)
      })
      return {
        ...rowSelection,
        selectedRowKeys: getAllSelectedRecordIds(),
      }
    })
  }

  const throttleOnChange = useMemo(() => {
    return _.throttle(onChange, 60)
  }, [])



  const allSelectedSize = useMemo(() => {
    return allSelectedRecordsRef.current.size || 0
  }, [allSelectedRecordsRef.current.size])


  const allSelectedRecords = useMemo(() => {
    return getAllSelectedRecords()
  }, [Array.from(allSelectedRecordsRef.current.keys() || []).join()])

  const allSelectedIds = useMemo(() => {
    throttleOnChange(getAllSelectedRecordIds(), getAllSelectedRecords())
    return getAllSelectedRecordIds()
  }, [Array.from(allSelectedRecordsRef.current.keys() || []).join()])



  return {
    rowSelection,
    setRowSelection,
    selectedSize: allSelectedSize, //选中的数量
    allSelectedRecords, // 获取已选中的记录
    allSelectedIds, // 获取已选中的记录ID,
    clearRecord: clearRecordMap,
    removeRecord: removeRecordFromMap,
  }
}